<template>
  <div>
    <section class="clients_qrcode">
      <div class="wrapper">
        <div class="box">
          <div class="qrcode_title">
            <img src="@/assets/images/clients/icon_mobilenew_color1.svg" alt="qrcode_icon" class="qrcode_title_icon">
            掃描前往借聽
          </div>
          <figcaption>本頁僅提供試聽，掃描下載<b>一刻鯨選 App</b>，享受完整聆聽服務！</figcaption>
          <qrcode-vue :value="clientsQRCode" :size="125" level="H"></qrcode-vue>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
/* eslint-disable no-undef */
/* eslint eqeqeq: "off" */
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'ClientsHeader',
  components: {
    QrcodeVue
  },
  computed: {
    ...mapGetters([
      'clientsQRCode'
    ])
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.clients_qrcode {
  position: fixed;
  top: 120px;
  right: 4%;
  display: none;
  .wrapper {
    .box {
      width: 156px;
      border: 1px solid #E6E6E6;
      border-radius: 10px;
      font-size: 1.3rem;
      background: #fff;
      >>> canvas {
        width: 100%!important;
        height: 100%!important;
      }
      .qrcode_title {
        font-size: 14px;
        color: rgb(23, 110, 141);
        font-weight: 600;
        background-color: rgba(23, 110, 141, 0.1);
        padding: 10px;
        border-radius: 10px 10px 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .qrcode_title_icon {
          margin-right: 8px;
        }
      }
      > * {
        padding: 0 10px;
        margin-bottom: 10px;
      }
      figcaption b {
        font-weight: normal; color: #176E8D;
      }
    }
  }
}

@media screen and (min-width: 1154px) {
  .clients_qrcode {
    display: block;
  }
}
@media screen and (min-width: 1280px) {
  .clients_qrcode {
    right: 2%;
  }
}
@media screen and (min-width: 1500px) {
  .clients_qrcode {
    right: 1%;
  }
}
@media screen and (min-width: 1700px) {
  .clients_qrcode {
    right: 7%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/clients/components/ClientsQRcode.vue